import React from 'react';
import { Link } from 'react-router-dom';
import { drapcodeIcon } from '../../common/custom/icon-library';
import {
  AIRTABLE,
  APPWRITE,
  APP_WRITE,
  AURORA,
  DIRECTUS,
  MARIADB,
  MS_SQL_SERVER,
  MYSQL,
  ORACLEDB,
  POSTGRESQL,
  SALESFORCE,
  SQLITE,
  SUPABASE,
  XANO,
  XATA,
} from 'drapcode-constant';

const showIcon = (source) => {
  switch (source) {
    case APPWRITE:
      return (
        <img
          src={require('../../common/dataSource/img/appwrite.svg')}
          alt={'Appwrite'}
          className="mr-3 svg"
        />
      );
    case XANO:
      return (
        <img
          src={require('../../common/dataSource/img/xano.svg')}
          alt={'Xano'}
          className="mr-3 svg"
        />
      );
    case SUPABASE:
      return (
        <img
          src={require('../../common/dataSource/img/supabase.svg')}
          alt={'Supabase'}
          className="mr-3 svg"
        />
      );
    case XATA:
      return (
        <img
          src={require('../../common/dataSource/img/xata.svg')}
          alt={'Xata'}
          className="mr-3 svg"
        />
      );
    case DIRECTUS:
      return (
        <img
          src={require('../../common/dataSource/img/directus.svg')}
          alt={'Directus'}
          className="mr-3 svg"
        />
      );
    case AIRTABLE:
      return (
        <img
          src={require('../../common/dataSource/img/airtable.svg')}
          alt={'Airtable'}
          className="mr-3 svg"
        />
      );
    case SALESFORCE:
      return (
        <img
          src={require('../../common/dataSource/img/salesforce.svg')}
          alt={'Salesforce'}
          className="mr-3 svg"
        />
      );
    case POSTGRESQL:
      return (
        <img
          src={require('../../common/dataSource/img/postgresql.svg')}
          alt={'PostgreSQL'}
          className="mr-3 svg"
        />
      );
    case MYSQL:
      return (
        <img
          src={require('../../common/dataSource/img/mysql.svg')}
          alt={'MySQL'}
          className="mr-3 svg"
        />
      );
    case SQLITE:
      return (
        <img
          src={require('../../common/dataSource/img/sqlite.svg')}
          alt={'SQLite'}
          className="mr-3 svg"
        />
      );
    case MS_SQL_SERVER:
      return (
        <img
          src={require('../../common/dataSource/img/ms-sql-server.svg')}
          alt={'MS SQL Server'}
          className="mr-3 svg"
        />
      );
    case ORACLEDB:
      return (
        <img
          src={require('../../common/dataSource/img/oracledb.svg')}
          alt={'OracleDB'}
          className="mr-3 svg"
        />
      );
    case MARIADB:
      return (
        <img
          src={require('../../common/dataSource/img/mariadb.svg')}
          alt={'MariaDB'}
          className="mr-3 svg"
        />
      );
    case AURORA:
      return (
        <img
          src={require('../../common/dataSource/img/aurora.svg')}
          alt={'Aurora'}
          className="mr-3 svg"
        />
      );
    default:
      return <i className={`mr-3 wb ${drapcodeIcon(source)}`} />;
  }
};

const DataSourceLinks = ({ projectId, version, handleReload }) => {
  return (
    <div className="dropdown">
      <button
        className="btn btn-theme-submit btn-md dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i className="wb webconnect-plus"></i> Create DataSource
      </button>
      <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <Link
          className="dropdown-item"
          to={`/2.0/data-connector/${version}/v/${projectId}/appwrite-datasource`}
        >
          {showIcon(APPWRITE)}
          Appwrite
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/data-connector/${version}/v/${projectId}/xano-data-source`}
        >
          {showIcon(XANO)}
          Xano
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/data-connector/${version}/v/${projectId}/supabase-datasource`}
        >
          {showIcon(SUPABASE)}
          Supabase
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/data-connector/${version}/v/${projectId}/xata-datasource`}
        >
          {showIcon(XATA)}
          Xata
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/data-connector/${version}/v/${projectId}/directus-datasource`}
        >
          {showIcon(DIRECTUS)}
          Directus
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/data-connector/${version}/v/${projectId}/airtable-datasource`}
        >
          {showIcon(AIRTABLE)}
          Airtable
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/data-connector/${version}/v/${projectId}/salesforce-datasource`}
        >
          {showIcon(SALESFORCE)}
          Salesforce
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/collections/${version}/v/${projectId}/create-with-postgresql`}
        >
          {showIcon(POSTGRESQL)}
          PostgreSQL
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/data-connector/${version}/v/${projectId}/mysql-datasource`}
        >
          {showIcon(MYSQL)}
          MySQL
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/collections/${version}/v/${projectId}/create-with-sqlite`}
        >
          {showIcon(SQLITE)}
          SQLite
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/collections/${version}/v/${projectId}/create-with-ms-sql-server`}
        >
          {showIcon(MS_SQL_SERVER)}
          MS SQL Server
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/collections/${version}/v/${projectId}/create-with-oracledb`}
        >
          {showIcon(ORACLEDB)}
          OracleDB
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/collections/${version}/v/${projectId}/create-with-mariadb`}
        >
          {showIcon(MARIADB)}
          MariaDB
        </Link>
        <Link
          className="dropdown-item"
          to={`/2.0/collections/${version}/v/${projectId}/create-with-aurora`}
        >
          {showIcon(AURORA)}
          Aurora
        </Link>
        {/* Add more links as needed */}
      </div>
    </div>
  );
};

export default DataSourceLinks;
